/**
 * FE-specific shipping defaults for the Pixi Bundle checkout.
 *
 * The country allow-list (`HARDWARE_CHECKOUT_ALLOWED_COUNTRIES`) and the
 * country→bucket geography (`resolveCountryBucket` / `CountryBucket`) now come
 * from `@screencloud/billing-client-api` (5.4.0+) — import them from there
 * directly. This module only holds the FE's default preselected country, which
 * is a product decision rather than SDK data.
 */

/**
 * The country preselected in the "Ship to" dropdown / shipping form before the
 * user picks one. Must be a member of the SDK's
 * `HARDWARE_CHECKOUT_ALLOWED_COUNTRIES` allow-list.
 */
export const DEFAULT_HARDWARE_CHECKOUT_COUNTRY = "US";
